import { Input, message, Modal } from 'antd';
import dayjs from 'dayjs';
import { webimg } from './Variable';
export async function getyhzh(webPost) {
    if (window['yhzh']) return window['yhzh'];
    const z = await webPost('getyhzh', {});
    if (z) {
        window['yhzh'] = z;
        return window['yhzh'];
    } else {
        return [];
    }
}
export function getJsfs() {
    return ('银行转账/现金/银行承兑/商业承兑').split("/").map((v, i) => ({ id: i, name: v }));
}
export async function getComsName(webPost) {
    if (window['comsname']) return window['comsname'];
    const z = await webPost('getcomsname', {});
    if (z) {
        console.log('zzzzz', z);
        window['comsname'] = z.filter(it => Number(it.is_deleted) === 0).map((it) => { return { 'id': it.id, 'name': it.name } });
        return window['comsname'];
    } else {
        return [];
    }
}
export async function getKxSm(webPost, p) {
    const fp = 'kxsm' + p;
    if (window[fp]) return window[fp];
    try {
        const res = await webPost('cktypelist', { category: p });
        if (res) {
            window[fp] = res.map((it) => { return { 'id': it.id, 'name': it.name } });
            return window[fp];
        } else {
            return [];
        }
    } catch (error) {
        return [];
    }
}
export const getuptoken = async (webPost) => {
    if (window['upqitoken']) return window['upqitoken'];
    const z = await webPost('getuptoken', {});
    if (z) {
        window['upqitoken'] = z;
        return z;
    } else {
        window['upqitoken'] = null;
        return '';
    }
}
export const formatNumber = (num) => {
    let value = Number(num);
    if (isNaN(value)) return '-';
    if (Object.is(value, -0)) return 0;

    let rounded = parseFloat(value.toFixed(2));

    const formatTenThousand = (num) => {
        const [integerPart, decimalPart] = num.toString().split('.');
        const formattedInteger = integerPart
            .split('')
            .reverse()
            .reduce((acc, digit, index) => {
                if (index !== 0 && index % 4 === 0) {
                    acc.push(' ');
                }
                acc.push(digit);
                return acc;
            }, [])
            .reverse()
            .join('');

        return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
    };

    return formatTenThousand(rounded);
};
export const dayjsDate = (dt, itm) => {
    if (!dt) return null;
    if (typeof dt === 'string' && dt.includes(',') && itm) {
        const result = {};
        dt.split(",").filter(Boolean).forEach(field => {
            field = field.trim();
            result[field] = dayjsDate(itm[field]);
        });
        return result;
    }
    const d = new Date(dt);
    if (isNaN(d.getTime())) return null;
    const year = d.getFullYear();
    if (year < 2020) {
        return null;
    }
    return dayjs(d);
}
export const formatDate = (dt) => {
    if (!dt) return '';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '';
    const year = d.getFullYear();
    if (year < 2020) {
        return '';
    }
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export const formatDate2 = (dt, itm) => {
    if (!dt) return '2012-12-12';
    if (typeof dt === 'string' && dt.includes(',') && itm) {
        const result = {};
        dt.split(",").filter(Boolean).forEach(field => {
            field = field.trim();
            result[field] = formatDate2(itm[field]);
        });
        return result;
    }
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '2012-12-12';
    const year = d.getFullYear();
    if (year < 2020) {
        return '2012-12-12';
    }
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export const formatDateTime = (dt) => {
    if (!dt) return '';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '';
    const year = d.getFullYear();
    if (year < 2020) {
        return '';
    }
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
export const formatDateTime2 = (dt) => {
    if (!dt) return '2012-12-12 00:00:00';
    const d = new Date(dt);
    if (isNaN(d.getTime())) return '2012-12-12 00:00:00';
    const year = d.getFullYear();
    if (year < 2020) {
        return '2012-12-12 00:00:00';
    }
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
export const formatImg = (url) => {
    if (typeof url !== 'string' || url.trim() === '') {
        console.log('错误的url', url);
        return '';
    }
    const pureUrl = url.trim();

    if (pureUrl.startsWith('http://') || pureUrl.startsWith('https://')) {
        return pureUrl;
    }

    const web = webimg;
    const webWithoutTrailingSlash = web.endsWith('/') ? web.slice(0, -1) : web;
    const urlWithoutLeadingSlash = pureUrl.startsWith('/') ? pureUrl.slice(1) : pureUrl;
    return `${webWithoutTrailingSlash}/${urlWithoutLeadingSlash}`;
};
export const isTomorrow = (dateValue) => {
    if (!dateValue) return false;
    const rowDate = dayjs(dateValue);
    const tomorrow = dayjs().add(1, 'day').startOf('day');
    return rowDate.isValid() && rowDate.isSame(tomorrow, 'day');
};
export const parseToTimestamp = (str) => {
    if (typeof str === 'number') {
        return str < 1607731200000 ? 0 : str;
    }
    if (!str || typeof str !== 'string') {
        return 0;
    }

    let s = str.trim();
    if (s === '' || s === '0') return 0;

    // 统一替换各种分隔符为标准格式（保留空格用于分离时间）
    s = s
        .replace(/\s+/g, ' ')               // 多个空格合并为一个
        .replace(/[/．.]/g, '-')            // 中文句号、点、斜杠 → 短横线
        .replace(/年/g, '-')
        .replace(/月/g, '-')
        .replace(/日/g, '')
        .trim();

    // 尝试匹配：日期 + 可选时间
    // 支持：2025-12-16 9:00:30 或 2025-12-16 9:00 或 2025-12-16
    const datetimeRegex = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/;
    const match = s.match(datetimeRegex);

    if (match) {
        const [, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr] = match;
        const year = parseInt(yearStr, 10);
        const month = parseInt(monthStr, 10);
        const day = parseInt(dayStr, 10);
        const hour = hourStr ? parseInt(hourStr, 10) : 0;
        const minute = minuteStr ? parseInt(minuteStr, 10) : 0;
        const second = secondStr ? parseInt(secondStr, 10) : 0;

        // 验证日期有效性（防止 2025-02-30）
        const date = new Date(year, month - 1, day, hour, minute, second);
        if (
            date.getFullYear() === year &&
            date.getMonth() === month - 1 &&
            date.getDate() === day
        ) {
            const sp = date.getTime();
            return sp > 1607731200000 ? sp : 0;
        }
    }

    // 兜底：尝试原生 Date.parse（对 ISO 8601 等有效）
    const fallback = Date.parse(str);
    if (!isNaN(fallback)) {
        return fallback;
    }

    return 0; // 解析失败
};
export function preprocessQuotedFields(text) {
    return text.replace(/"((?:[^"]|"")*)"/g, (match, quotedContent) => {
        let unescaped = quotedContent.replace(/""/g, '"');
        unescaped = unescaped.replace(/\r\n|\n|\r/g, ' ');
        unescaped = unescaped.replace(/\t/g, ' ');
        return unescaped;
    });
}

export const exportToCSV = (dataSource, columns, title) => {
    // 工具函数：格式化日期为 yyyy-MM-dd
    const formatDate = (date) => {
        const d = new Date(date);
        if (isNaN(d.getTime())) return ''; // 非法日期返回空
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    // 工具函数：判断是否为 13 位毫秒时间戳
    const isTimestamp = (value) => {
        if (typeof value !== 'number') return false;
        const min = 0; // 1970
        const max = 4102444800000; // 2100-01-01
        return value >= min && value <= max && String(value).length === 13;
    };

    const convertToCSV = (data, headers) => {
        if (!data || data.length === 0) return '';

        const headerNames = headers.map(header => header.title);
        let csv = headerNames.join(',') + '\n';

        data.forEach(row => {
            const values = headers.map(header => {
                const value = row[header.dataIndex];

                if (value === null || value === undefined) return '';

                // 👇 关键：检测是否为毫秒时间戳
                let finalValue = value;
                if (isTimestamp(value)) {
                    finalValue = formatDate(value);
                } else {
                    finalValue = String(value);
                }

                // CSV 字段转义
                if (finalValue.includes(',') || finalValue.includes('"') || finalValue.includes('\n')) {
                    finalValue = finalValue.replace(/"/g, '""');
                    return `"${finalValue}"`;
                }
                return finalValue;
            });
            csv += values.join(',') + '\n';
        });

        return csv;
    };

    const csvContent = convertToCSV(dataSource, columns);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    const fs = title ? title : `导出数据_${new Date().toLocaleDateString('zh-CN')}`;
    link.setAttribute('download', `${fs}.csv`);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export const getMonthStartEnd = (date) => {
    const d = dayjs(date);
    return {
        startTs: d.startOf('month').format('YYYY-MM-DD HH:mm:ss'),
        endTs: d.endOf('month').format('YYYY-MM-DD HH:mm:ss'),
    };
};

export const getRangeStartEnd = (range) => {
    if (!range || !range[0] || !range[1]) {
        return { startTs: null, endTs: null };
    }
    //.valueOf()
    return {
        startTs: dayjs(range[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        endTs: dayjs(range[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    };
};
export function getDayDifferenceWithoutTime(date1, date2) {
    // 步骤1：转换为Date对象
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    // 步骤2：重置时分秒毫秒为0（忽略时间部分，只保留日期）
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);

    // 步骤3：获取时间戳、计算差值、转换为天数
    const timestamp1 = d1.getTime();
    const timestamp2 = d2.getTime();
    const msDifference = timestamp2 - timestamp1;
    const dayDifference = Math.floor(msDifference / 86400000); // 向下取整，得到整数天

    return dayDifference;
}
export const generateAlphabetHeaders = (count) => {
    const headers = [];
    for (let i = 0; i < count; i++) {
        if (i < 26) {
            headers.push(String.fromCharCode(65 + i)); // A-Z
        } else {
            // 支持 AA, AB...（可选）
            headers.push('A' + String.fromCharCode(65 + (i - 26)));
        }
    }
    return headers;
};
export const insertGroupSummaries = (data) => {
    if (!Array.isArray(data) || data.length === 0) return [];

    // 1. 深拷贝 + 排序：先按 dk，再按 ptime
    const sortedData = [...data].sort((a, b) => {
        return (a.ptime - b.ptime);
    });

    const result = [];
    let currentDk = null;
    let groupAmount = 0;
    let groupSj = 0;
    let groupKpj = 0;

    // 2. 遍历排序后的数据
    for (let i = 0; i < sortedData.length; i++) {
        const item = sortedData[i];
        const dk = String(item.dk);

        // 如果 dk 变化了，且不是第一组，插入上一组的小计
        if (currentDk !== null && currentDk !== dk) {
            result.push({
                sl: `小计`,
                ptime: '',
                amount: groupAmount,
                sj: groupSj,
                kpj: groupKpj,
                isSummary: true, // 标记为小计行，方便 Table 渲染样式
            });

            // 重置累加器
            groupAmount = 0;
            groupSj = 0;
            groupKpj = 0;
        }

        // 更新当前组
        currentDk = dk;
        groupAmount += Number(item.amount) || 0;
        groupSj += Number(item.sj) || 0;
        groupKpj += Number(item.kpj) || 0;

        // 推入原始行
        result.push(item);
    }

    // 3. 插入最后一组的小计
    if (currentDk !== null) {
        result.push({
            sl: `小计`,
            ptime: '',
            amount: groupAmount,
            sj: groupSj,
            kpj: groupKpj,
            isSummary: true,
        });
    }

    // 4. 【可选】插入总计行
    const totalAmount = result
        .filter(row => !row.isSummary && !row.isTotal)
        .reduce((sum, row) => sum + (Number(row.amount) || 0), 0);
    const totalSj = result
        .filter(row => !row.isSummary && !row.isTotal)
        .reduce((sum, row) => sum + (Number(row.sj) || 0), 0);
    const totalKpj = result
        .filter(row => !row.isSummary && !row.isTotal)
        .reduce((sum, row) => sum + (Number(row.kpj) || 0), 0);

    result.push({
        sl: '总计',
        ptime: '',
        amount: totalAmount,
        sj: totalSj,
        kpj: totalKpj,
        isTotal: true,
    });

    return result;
};
export const getLkoptions = () => {
    if (window['jsdwlkoption']) return window['jsdwlkoption'];
    return ['测试', '测试2']
}
export const getAdmin = () => {
    if (window['admuser']) {
        return window['admuser'];
    }

    try {
        const adminStr = localStorage.getItem('admin');
        if (adminStr) {
            const admin = JSON.parse(adminStr);
            if (admin && admin.token) {
                window['admuser'] = admin;
                return admin;
            }
        }
    } catch (e) {
        console.warn('Failed to parse admin from localStorage', e);
        localStorage.removeItem('admin');
    }
    return null;
}
export const checkp = (keys) => {
    const admin = window['admuser'];
    if (!admin) return false;

    const permission = admin['permission'] || [];
    if (!permission || permission.length === 0) return false;

    if (permission.includes('all')) return true;
    const targetKeys = Array.isArray(keys) ? keys : String(keys).split(",");
    const result = targetKeys.some(key => permission.includes(String(key)));
    return result;
};
export const delrecord = async (webPost, action, id, onDel, onCancel, title) => {
    const delf = async () => {
        const res = await webPost(action, { id });
        if (res) {
            onDel && onDel();
        }
    }
    confirmBox(delf, onCancel, title);
}
export const confirmBox = (onOk, onCancel, title = '确认操作') => {
    let inputvalue = '', inputvalue2 = Math.round(Math.random() * 1000);
    Modal.confirm({
        title: title,
        content: (<div>
            <div><span>请在下面输入</span><span style={{ 'fontWeight': 800, 'fontSize': '1.05rem', 'paddingLeft': '12px' }}>{inputvalue2}</span></div>
            <div><Input onChange={(e) => inputvalue = e.target.value} /></div>
        </div>),
        onOk: (() => { if (inputvalue.toString() === inputvalue2.toString()) { onOk && onOk() } else { message.error('确认码不正确') } }),
        onCancel: (() => { onCancel && onCancel() })
    })
}
export function ensureValidUrl(url) {
    if (!url) return null;

    url = url.trim();

    if (url.startsWith('http://') || url.startsWith('https://')) {
        try {
            new URL(url);
            return url;
        } catch {
            return null;
        }
    }

    const withHttps = 'https://' + url;
    try {
        new URL(withHttps);
        return withHttps;
    } catch { }

    const withHttp = 'http://' + url;
    try {
        new URL(withHttp);
        return withHttp;
    } catch { }

    return null;
}
export function getobjkeys(obj) {
    const keysArray = Object.keys(obj);
    const keysStr = keysArray.join(',');
    return keysStr;
}

/**
 * 按属性名累加单个对象中的值，非数字值自动转为0
 * @param {string|string[]} props - 要累加的属性名（数组 | 逗号分隔的字符串）
 * @param {object} objs - 数据源（单个对象，无需数组）
 * @returns {number} 累加后的结果
 */
export function sumProps(props, objs) {
    // 1. 统一属性名格式：数组 | 逗号分隔字符串 → 数组
    const propList = Array.isArray(props)
        ? props
        : props.split(',').map(prop => prop.trim());

    // 2. 初始化累加结果
    let total = 0;

    // 3. 遍历属性名，从单个对象中取值累加
    propList.forEach(prop => {
        if (!prop) return;
        const value = Number(objs[prop]) || 0;
        console.log('属性名：', prop, '| 原始值：', objs[prop], '| 转数字后：', value, '| 数据源对象：', objs);
        total += value;
    });

    return total;
}

/**
 * 获取指定天数前的日期（支持格式化）
 * @param {number} days - 往前/后推的天数（如-3=近3天，7=后7天）
 * @param {boolean} [format=true] - 是否返回格式化字符串（YYYY-MM-DD），false返回Date对象
 * @returns {Date|string} 目标日期
 */
export function addDays(days, isEndTs = 0) {
    const targetDate = new Date();

    targetDate.setDate(targetDate.getDate() + days);

    if (isEndTs) {
        return dayjs(targetDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    } else {
        return dayjs(targetDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    }
}
export function debounce(fn, delay) {
    let timer = null;
    return function (...args) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
}